import { getCookieValue } from '@economic/http-client';

const VERSION_TOKEN = '_x_client_version';

function deleteCookie(name: string) {
    document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
}

function showClientVersion(clientVersion: string) {
    const element = document.createElement('div');
    element.textContent = `Client version: ${clientVersion}`;

    const closeBtn = document.createElement('span');
    closeBtn.innerHTML = '&times;'; // '×' close symbol
    closeBtn.style.cssText = `
        margin-left: 8px;
        cursor: pointer;
        font-weight: bold;
    `;

    closeBtn.onclick = () => {
        deleteCookie(VERSION_TOKEN);
        window.location.reload();
    };

    element.appendChild(closeBtn);

    Object.assign(element.style, {
        position: 'fixed',
        bottom: '12px',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#FFBD3B',
        color: '#000',
        border: '1px solid #E89C2E',
        padding: '6px 12px',
        borderRadius: '6px',
        fontFamily: 'monospace',
        fontSize: '12px',
        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.2)',
        display: 'flex',
        alignItems: 'center',
        zIndex: '9999',
        transition: 'background 0.2s ease-in-out',
    });

    document.body.appendChild(element);
}

// Report client version if present in URL or cookies
const params = new URLSearchParams(window.location.search);
const clientVersionPreview = params.get(VERSION_TOKEN) || getCookieValue(VERSION_TOKEN);

if (clientVersionPreview) {
    showClientVersion(decodeURIComponent(clientVersionPreview).trim());
}
